"use client";
import DWorkLogo from "@/imports/dw-logo";

function CompanyIntroLink() {
  return (
    <a 
      href="https://www.ibank.co.kr" 
      target="_blank" 
      rel="noopener noreferrer"
      className="content-stretch flex gap-1.5 items-center justify-start relative shrink-0 cursor-pointer hover:opacity-80 transition-opacity"
    >
      <div className="font-['Pretendard:Medium',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#ffffff] text-[18px] lg:text-[20px] tracking-[-0.36px] lg:tracking-[-0.4px]">
        <p className="leading-[normal]">회사소개</p>
      </div>
      <div className="relative shrink-0 size-3 lg:size-3.5">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 14 14">
          <path d="M0 7H7M14 7H7M7 7V0V14" stroke="var(--stroke-0, white)" strokeWidth="1.4" />
        </svg>
      </div>
    </a>
  );
}

function ServiceIntroLink() {
  return (
    <a 
      href="/about" 
      className="font-['Pretendard:Medium',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#ffffff] text-[18px] lg:text-[20px] tracking-[-0.36px] lg:tracking-[-0.4px] cursor-pointer hover:opacity-80 transition-opacity"
    >
      <p className="leading-[normal]">서비스 소개</p>
    </a>
  );
}

function TopLinksArea() {
  return (
    <div className="content-stretch flex flex-col lg:flex-row gap-3 lg:gap-8 items-center justify-end relative shrink-0">
      <CompanyIntroLink />
      <ServiceIntroLink />
    </div>
  );
}

function VerticalDivider() {
  return (
    <div className="h-3 relative shrink-0 w-0">
      <div className="absolute bottom-0 left-[-0.5px] right-[-0.5px] top-0">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 2 12">
          <path d="M1 0V12" stroke="var(--stroke-0, white)" strokeOpacity="0.4" />
        </svg>
      </div>
    </div>
  );
}

function CompanyAddress() {
  return (
    <div className="content-stretch flex flex-col lg:flex-row gap-2 lg:gap-4 items-center justify-end relative shrink-0 w-full">
      <div className="font-['Pretendard:Regular',_sans-serif] leading-[0] not-italic relative shrink-0 text-[14px] lg:text-[16px] text-[rgba(255,255,255,0.8)] tracking-[-0.28px] lg:tracking-[-0.32px] text-center lg:text-left">
        <p className="leading-[normal]">㈜아이뱅크[디지털웍스]</p>
      </div>
      <div className="hidden lg:block">
        <VerticalDivider />
      </div>
      <div className="font-['Pretendard:Regular',_sans-serif] leading-[0] not-italic relative shrink-0 text-[14px] lg:text-[16px] text-[rgba(255,255,255,0.8)] tracking-[-0.28px] lg:tracking-[-0.32px] text-center lg:text-left">
        <p className="leading-[normal]">서울 강서구 마곡동로 166 마곡보타닉게이트 10층</p>
      </div>
    </div>
  );
}

function ContactInfo() {
  return (
    <div className="content-stretch flex flex-col lg:flex-row gap-2 lg:gap-4 items-center justify-end relative shrink-0 w-full min-h-[20px] lg:h-5">
      <div className="font-['Pretendard:Regular',_sans-serif] leading-[0] not-italic relative shrink-0 text-[14px] lg:text-[16px] text-[rgba(255,255,255,0.8)] tracking-[-0.28px] lg:tracking-[-0.32px] text-center lg:text-left">
        <p className="leading-[normal]">Email : support@dwinsights.com</p>
      </div>
      <div className="hidden lg:block">
        <VerticalDivider />
      </div>
      <div className="font-['Pretendard:Regular',_sans-serif] leading-[0] not-italic relative shrink-0 text-[14px] lg:text-[16px] text-[rgba(255,255,255,0.8)] tracking-[-0.28px] lg:tracking-[-0.32px] text-center lg:text-left">
        <p className="leading-[normal]">대표자명 : 정용관</p>
      </div>
    </div>
  );
}

function CompanyInfo() {
  return (
    <div className="content-stretch flex flex-col gap-2 lg:gap-3 items-end justify-start relative shrink-0 w-full">
      <CompanyAddress />
      <ContactInfo />
    </div>
  );
}

function RightCompanyArea() {
  return (
    <div className="lg:[grid-area:1_/_2] content-stretch flex flex-col gap-4 lg:gap-6 items-center lg:items-end justify-start overflow-clip relative shrink-0">
      <TopLinksArea />
      <CompanyInfo />
    </div>
  );
}

function LogoAndSlogan() {
  return (
    <div className="basis-0 content-stretch flex flex-col gap-2 grow items-center lg:items-start justify-start min-h-px min-w-px overflow-clip relative shrink-0">
      <div className="h-[18px] lg:h-[21px] relative shrink-0 w-[200px] lg:w-[248px]">
        <DWorkLogo />
      </div>
      <div className="font-['Spoqa_Han_Sans_Neo:Regular',_sans-serif] leading-[0] w-[200px] lg:w-[248px] not-italic relative shrink-0 text-[#ffffff] text-[12px] lg:text-[14px] tracking-[-0.24px] lg:tracking-[-0.28px] text-center lg:text-left">
        <p className="leading-[1.3]">{`Data Marketing & Solution Consultancy`}</p>
      </div>
    </div>
  );
}

function LeftLogoArea() {
  return (
    <div className="[grid-area:1_/_1] content-stretch flex gap-2.5 items-start justify-start relative shrink-0">
      <LogoAndSlogan />
    </div>
  );
}

function TopTwoColumnArea() {
  return (
    <div className="flex flex-col lg:grid grid-cols-1 lg:grid-cols-[repeat(2,_minmax(0px,_1fr))] grid-rows-[repeat(2,_minmax(0px,_1fr))] lg:grid-rows-[repeat(1,_minmax(0px,_1fr))] gap-4 lg:gap-0 relative shrink-0 w-full max-w-[1560px]">
      <LeftLogoArea />
      <RightCompanyArea />
    </div>
  );
}

function CompanySection() {
  return (
    <div className="content-stretch flex flex-col items-center justify-start relative shrink-0 w-full max-w-[1560px]">
      <TopTwoColumnArea />
    </div>
  );
}

function HorizontalDivider() {
  return (
    <div className="h-0 relative shrink-0 w-full max-w-[1560px]">
      <div className="absolute bottom-[-0.5px] left-0 right-0 top-[-0.5px]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 1560 2">
          <path d="M0 1H1560" stroke="var(--stroke-0, white)" strokeOpacity="0.2" />
        </svg>
      </div>
    </div>
  );
}

function BottomLinksArea() {
  return (
    <div className="lg:[grid-area:1_/_2] content-stretch flex flex-col lg:flex-row font-['Pretendard:Regular',_sans-serif] gap-2 lg:gap-6 items-center lg:justify-end leading-[0] not-italic relative shrink-0 text-[12px] lg:text-[14px] text-[rgba(255,255,255,0.6)] text-center lg:text-right tracking-[-0.24px] lg:tracking-[-0.28px]">
      <a href="/terms/service" className="relative shrink-0 cursor-pointer hover:opacity-80 transition-opacity">
        <p className="leading-[normal]">서비스 이용약관</p>
      </a>
      <a href="/terms/privacy" className="relative shrink-0 cursor-pointer hover:opacity-80 transition-opacity">
        <p className="leading-[normal]">개인정보 처리방침</p>
      </a>
      <a href="/terms/marketing" className="relative shrink-0 cursor-pointer hover:opacity-80 transition-opacity">
        <p className="leading-[normal]">마케팅 수신동의 약관</p>
      </a>
    </div>
  );
}

function BottomCopyrightArea() {
  return (
    <div className="flex flex-col lg:grid grid-cols-1 lg:grid-cols-[repeat(2,_minmax(0px,_1fr))] grid-rows-[repeat(2,_minmax(0px,_1fr))] lg:grid-rows-[repeat(1,_minmax(0px,_1fr))] gap-3 lg:gap-0 relative shrink-0 w-full max-w-[1560px]">
      <BottomLinksArea />
      <div className="lg:[grid-area:1_/_1] font-['Pretendard:Regular',_sans-serif] leading-[0] not-italic opacity-60 relative shrink-0 text-[#ffffff] text-[12px] lg:text-[14px] tracking-[-0.24px] lg:tracking-[-0.28px] text-center lg:text-left">
        <p className="leading-[normal]">Copyright © 2025 ibank. All Rights Reserved.</p>
      </div>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="bg-[#838588] relative w-full">
      <div className="flex flex-col items-center min-w-inherit relative w-full">
        <div className="box-border content-stretch flex flex-col gap-6 lg:gap-8 items-center justify-start min-w-inherit px-4 lg:px-8 py-6 lg:py-8 relative w-full">
          <CompanySection />
          <HorizontalDivider />
          <BottomCopyrightArea />
        </div>
      </div>
    </footer>
  );
}

